import { render } from "./GuestForm.vue?vue&type=template&id=5dd2129c"
import script from "./GuestForm.vue?vue&type=script&lang=js"
export * from "./GuestForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__